import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductActionsHistory = createAsyncThunk<
    { guid: string; productActionsHistory: any },
    { guid: string },
    ThunkConfig<string>
>('actionsSlice/fetchProductActionsHistory', async (arg, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid } = arg

    try {
        const { data } = await api.get(getUrlWithVersion(`/actions`), {
            params: {
                product_id: guid,
            },
        })

        return { guid, productActionsHistory: data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch actions history records')
    }
})
